import {AlertService} from '../../shared/services/alert.service';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AssessmentService } from "../../shared/services/assessment.service";
import { QuestionSet } from "../../shared/models/question-set";
import { QuestionSetLabel } from "../../shared/models/question-set-label";
import { Question } from "../../shared/models/question";
import { SaveMessages } from "../../shared/models/save-messages";
import { Assessment } from "../../shared/models/assessment";
import { DisplayCondition } from "../../shared/models/display-condition";
import { QuestionSetType } from "../../shared/models/question-set-type";
@Component({
  selector: 'app-question-set-edit',
  templateUrl: './question-set-edit.component.html',
  styleUrls: ['./question-set-edit.component.css']
})
export class QuestionSetEditComponent implements OnInit {

	private _questionSet:QuestionSet;
	private assessment:Assessment;

  constructor(
    private _assessmentService:AssessmentService
    ,private route:ActivatedRoute
    ,private router:Router
		,private location:Location
		,private alertService:AlertService
  ) {
    this.questionSet = new QuestionSet();
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let assessmentUid = params['uid'];
      let setId = params['setId'];
      this._assessmentService.getAssessment(assessmentUid)
        .then((assessment:Assessment) => {
          this.assessment = assessment;
          this.questionSet = assessment.question_sets.find((s) => s.id == setId);
					console.log(this.questionSet);
          if (!this.questionSet) {
            // TODO: stephen should we navigate back?? or do some kind of 404?
            this.router.navigate(["not-found"]);
          }
        });
    });
  }

	get Assessment() {
		return this.assessment;
	}

	public hasConditions(questionSet:QuestionSet) {
		return questionSet.display_conditions && questionSet.display_conditions.length > 0;
	}

	public toggleCondition(questionSet:QuestionSet) {
		if (this.hasConditions(questionSet)) {
			questionSet.display_conditions = [];
		}
		else {
			// set it with a new display condition
			questionSet.display_conditions.push(new DisplayCondition());
		}
	}

	get Condition() : DisplayCondition {
		return this._questionSet.display_conditions[0];
	}

  get questionSet() : QuestionSet {
    return this._questionSet;
  }

  set questionSet(v:QuestionSet) { 
    this._questionSet = v;
  }

  goBack() {
    this.location.back();
  }

	moveDownLabel(label:QuestionSetLabel) {
		this.questionSet.shiftLabelDown(label);
		this.save();
	}
	
	moveUpLabel(label:QuestionSetLabel) {
		this.questionSet.shiftLabelUp(label);
		this.save();
	}
	
	moveUpQuestion(question:Question) {
		this.questionSet.shiftQuestionUp(question);
		this.save();
	}
	
	moveDownQuestion(question:Question) {
		this.questionSet.shiftQuestionDown(question);
		this.save();
	}
	
	save() {
		this._assessmentService.saveAssessment(this.assessment).then((assessment) => {
				this.alertService.success("Question Set saved");
    }).catch((error) => {
			this.alertService.error("Question Set failed to save.  Please try again or contact customer support.");
      console.error(error);
    });
	}
	
	deleteQuestion(question) {
		if (!confirm("Are you sure you want to delete this question?")) {
			return; 
		}
		this.questionSet.removeQuestion(question);
		// TODO: stephen need messaging for removing a question, at least if it fails
    this.saveDeleteItem(this.assessment);
	}
	
	deleteLabel(label) {
		if (!confirm("Are you sure you want to delete this label?")) {
			return; 
		}
		this.questionSet.removeLabel(label);
		this.saveDeleteItem(this.assessment);
	}

	showQuestionLabelsForType(type) {
		if (type != QuestionSetType[type]) {
			return true;
		}
		return false;
	}

  private saveDeleteItem(assessment) {
    this._assessmentService.saveAssessment(this.assessment).then((assessment) => {
			this.alertService.error("Item deleted.");
    }).catch((error) => {
			this.alertService.error("Failed to delete item.  Please try again or contact customer support.");
      console.error(error);
		});
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/question-set-edit/question-set-edit.component.ts